export class ISetting {
  id: number;
  name: string;
  displayName: string;
  value: string;
  type: string;
  settingListOptions: string;
  settingTypeOptions: string;
  settingTypeValue: string;
  settingType: string;
  settingListOptionsUrl: string;
  hospitalId: number;
  allowMultipleValues: boolean;
  productCategory: string;
  feature: string;

  public constructor(setting?: Partial<ISetting>) {
    Object.assign(this, setting);
  }
}

export interface ISettingGroup {
  hospital: string;
  settings: ISetting[];
}

export interface ISettingOption {
  name: string;
  value: string;
}
